import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_tenant_budget_allocation: { message: "idle" },
};

export const add_tenant_budget_allocation_Slice = createSlice({
 name: "add_tenant_budget_allocation",
 initialState,
 reducers: {
  success_add_tenant_budget_allocation: (state, action) => {
   state.add_tenant_budget_allocation = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_tenant_budget_allocation: (state, action) => {
   state.add_tenant_budget_allocation = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_tenant_budget_allocation: (state) => {
   state.add_tenant_budget_allocation = { status: app_consts.IDLE };
  },
  loading_add_tenant_budget_allocation: (state) => {
   state.add_tenant_budget_allocation = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_tenant_budget_allocation, fail_add_tenant_budget_allocation, reset_add_tenant_budget_allocation, loading_add_tenant_budget_allocation } = add_tenant_budget_allocation_Slice.actions;

export default add_tenant_budget_allocation_Slice.reducer;